<template>
  <v-app>
    <notify />
    <RefreshAppAlert />
    <v-content class="layout--full-page">
      <div class="header--full-page d-flex align-center px-5" style="width: 100%">
        <img class="full-logo" v-bind:src="logoUrl" style="padding: 10px" />
        <v-spacer />
        <div class="justify-end">
          <lang-switcher />
        </div>
      </div>
      <v-container>
        <v-container fluid class="login-form-container login-container fill-height justify-center">
          <v-row justify="center" :class="needToResize ? 'flex-column-reverse align-center' : ''">
            <v-col sm="8" md="7" lg="8" xl="6">
              <v-row class="pt-5" align="center">
                <v-col class="d-flex flex-column">
                  <dr-layout-placeholder :model="{ $ID: 'pl4' + this.routeName, Name: 'InfoPage' }"></dr-layout-placeholder>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="10" sm="7" md="5" lg="4" xl="4">
              <v-row class="pt-5" align="center">
                <v-col class="d-flex flex-column">
                  <dr-layout-placeholder :model="{ $ID: 'pl3' + this.routeName, Name: 'LoginInfo' }"></dr-layout-placeholder>
                </v-col>
              </v-row>
              <v-row class="justify-center" align="end">
                <v-card hover class="d-flex align-end mt-16 pt-16 display: fixed; bottom: 0;" color="transparent" elevation="0">
                  <v-card-actions class="position: absolute; mt-16 pt-16">
                    <v-card-text class="white--text text-center mt-13 pt-13">
                      <!-- <a class="white--text" style="text-decoration: none" :href="'https://it-enterprise.com/'">{{ new Date().getFullYear() }} Powered by It-enterprise</a> -->
                    </v-card-text>
                  </v-card-actions>
                </v-card>
              </v-row>
            </v-col>
          </v-row>
        </v-container>
      </v-container>
      <div class="footer--full-page d-flex justify-space-around pb-1" style="width: 100%">
        <a class="white--text" style="text-decoration: none" :href="'https://it-enterprise.com/'">2021 Powered by It-enterprise</a>
      </div>
    </v-content>
  </v-app>
</template>

<script>
import Notify from '@/components/Notify'
import LangSwitcher from '@/components/LangSwitcher'
import inputMixin from '@it-enterprise/web-app-common/src/mixins/input-mixin'
import layoutMixin from '@it-enterprise/web-app-common/src/mixins/layout-mixin'
import RefreshAppAlert from '@/components/RefreshAppAlert'

export default {
  name: 'ExtendedFullPageLayout',
  mixins: [inputMixin, layoutMixin],
  components: {
    Notify,
    LangSwitcher,
    RefreshAppAlert
  },
  computed: {
    routeName() {
      return this.$route.name
    }
  }
}
</script>

<style scoped>
.layout--full-page {
  background: url(../assets/energo/full-page-bg.svg) center bottom/cover no-repeat;
}

.header--full-page {
  position: fixed;
}

.full-logo {
  max-width: 150px; 
}
</style>
